import { createAsyncThunk } from "@reduxjs/toolkit";
import * as profileApi from "../../api/requests/profile";

export const getNewUsers = createAsyncThunk("users/getNewUsers", async () => {
  try {
    const response = await profileApi.getNewUsers();
    return response;
  } catch (error) {
    return error;
  }
});
